<template>
  <div class="service">
      <div class="PublicCss serviceBox3">
         <h4>部分客户说明</h4>
         <div class="logosBox">
            <img src="../assets/img/h_entLogo1.png" />
            <img src="../assets/img/h_entLogo2.png" />
            <img src="../assets/img/h_entLogo3.png" />
         </div>
      </div>

      <div class="serviceBox4">
          <h4>部分客户使用反馈</h4>
          <ul class="clear">
              <li>
                <div class="logo"><img src="../assets/img/h_helpEnt1.png" /></div>
                <p class="tit">物流绿叶借助小语机器人，提升80%的工作效率</p>
					      <p class="txt">物流绿页致力于通过为中小物流企业解决核心痛点，运用中小物流企业管家服务及物流金融二个项目引擎，推动并做大物流绿页平台，最终实现物流行业“降本增效”，目前已在全国9个省新设立10个城市基地。使用小语机器人后，物流绿叶只需要原1/3的话务人员即可完成既定的客户销售沟通任务，用电话机器人打电话，不仅为物流绿叶节省了大量的人力成本，还让其工作效率大幅提升了80%；</p>
              </li>
              <li>
                <div class="logo"><img src="../assets/img/h_helpEnt2.png" /></div>
                <p class="tit">链家房产利用小语机器人，轻松完成招聘任务</p>
                <p class="txt">链家房产成立于2001年，是一家集房产交易服务、资产管理服务为一体以数据驱动的价值链房产服务平台，目前已覆盖北京、上海、广州、深圳等28个地区，全国门店数量约8000家，旗下经纪人超过13万名。链接的快速发展，让他们每年都有大量的人员招聘任务。由于招聘人员需要一直拨打电话，总会有负面情绪的反应、并且容易疲惫。当他们使用小语机器人招聘后，拥有标准化的话术、标准化的分类、标准化的情绪的机器人，轻松而又高效地帮助其完成了招聘任务。</p>
              </li>
              <li>
                <div class="logo"><img src="../assets/img/h_helpEnt3.png" /></div>
                <p class="tit">衣邦人与小语机器人深度合作，增加了62%的订单转化率</p>
                <p class="txt">衣邦人首创将“互联网+上门量体+工业4.0”引入服装定制，致力于打造全球时尚C2M平台。目前在中国拥有35个子公司，服务范围包含近200个城市，已成为中国互联网服务定制行业遥遥领先的标杆企业。每天衣邦人的话务人员需要拨打大量电话为客户推荐其产品服务，然而会有很多电话属于空号错号或无法接通中，浪费了大量的工作时间进行客户筛选。而小语机器人直接过滤无用的电话号码，高效筛选出意向客户资料，提升了62%的订单转化率。</p>
              </li>
          </ul>
      </div>


      <div class="PublicCss serviceBox1">
         <h4>生命周期管理</h4>
         <ul class="clear">
            <li>
	          	  <i><img src="../assets/img/h-ser1.png" /></i>
	          	  <h6>产品专业</h6>
	          	  <p>20年人工智能研究经验</p>
                <p>15年通讯行业研发经验</p>
	          </li>
            <li>
	          	  <i><img src="../assets/img/h-ser2.png" /></i>
	          	  <h6>流程保障</h6>
	          	  <p>标准运营交付流程</p>
                <p>保障产品的极速交付</p>
                <p>也保证产品的稳定运行</p>
	          </li>
            <li>
	          	  <i><img src="../assets/img/h-ser3.png" /></i>
	          	  <h6>客户导向</h6>
	          	  <p>以客户为导向</p>
                <p>以结果为导向</p>
                <p>为客户创造价值</p>
	          </li>
            <li>
	          	  <i><img src="../assets/img/h-ser4.png" /></i>
	          	  <h6>成功多赢</h6>
	          	  <p>为客户提供专业的产品</p>
                <p>向客户学习行业的知识</p>
                <p>共同成长，实现共赢</p>
	          </li>
         </ul>
      </div>

      <div class="serviceBox2">
          <ul >
            <li class="clear">
		             	 <i><img src="../assets/img/h-serT1.png"/></i>
		               <h6>系统安全</h6>
		               <div class="serviceTxt clear">
		               	 <p class="te"><img src="../assets/img/h-item1.png"/><span>防渗透</span></p>
		               	 <p><img src="../assets/img/h-item2.png"/><span>防篡改</span></p>
		               	 <p class="Noline"><img src="../assets/img/h-item3.png"/><span>漏洞防护</span></p>
		               </div>
		           </li>
		           <li class="clear">
		                <i><img src="../assets/img/h-serT2.png"/></i>
		                <h6>网络安全</h6>
		                <div class="serviceTxt clear">
		               	 <p class="te"><img src="../assets/img/h-item4.png"/><span>Ddos</span></p>
		               	 <p><img src="../assets/img/h-item5.png"/><span>IPS</span></p>
		               	 <p class="Noline"><img src="../assets/img/h-item6.png"/><span>IDS</span></p>
		               	 <p class="te"><img src="../assets/img/h-item7.png"/><span>分级权限</span></p>
		               	 <p><img src="../assets/img/h-item8.png"/><span>访问留痕</span></p>
		                </div>
		           </li>
		           <li class="clear">
		                <i><img src="../assets/img/h-serT3.png"/></i>
		                <h6>数据安全</h6>
		                <div class="serviceTxt clear">
		               	 <p class="te"><img src="../assets/img/h-item9.png"/><span>防泄漏</span></p>
		               	 <p><img src="../assets/img/h-item10.png"/><span>双活热备</span></p>
		               	 <p class="Noline"><img src="../assets/img/h-item11.png"/><span>异地灾备</span></p>
		               	 <p class="te"><img src="../assets/img/h-item12.png"/><span>数据恢复</span></p>
		               	 <p><img src="../assets/img/h-item13.png"/><span>数据加密</span></p>
		               	 <p class="Noline"><img src="../assets/img/h-item14.png"/><span>数据防护</span></p>
		                </div>
		           </li>
          </ul>
      </div>

      <Popup v-show="$store.state.isshow"></Popup>
  </div>
</template>

<script>
import Popup from "@/components/popup"
export default {
  name: 'service',
  data () {
    return {
      
    }
  },
 components:{
      Popup
  },
}
</script>


<style scoped>
.service{
   margin-top:0.85rem;
}
.service .PublicCss{
   background:#fff;
   padding-bottom:0.1rem;
}
.PublicCss.serviceBox1 ul{
  width:110%;
}
.PublicCss.serviceBox1 ul li{
    width: 3rem;
    float: left;
    padding:0rem;
    margin: 0rem 0rem 0rem 0.5rem;
    height: 4.2rem;
}
.PublicCss.serviceBox1 ul li h6 {
    font: 0.32rem/0.78rem 'MicrosoftYaHei';
}
.PublicCss.serviceBox1 ul li p {
    font: 0.26rem/0.5rem 'MicrosoftYaHei';
}
.PublicCss.serviceBox1 ul li i{
  width:1.5rem;
  height:1.5rem;
}
.PublicCss.serviceBox1 ul li i img{
  width:1.5rem;
  height:1.5rem;
}
.serviceBox1{
  padding:1rem 0 0.6rem 0;
}
.serviceBox1 h4{
  padding-bottom:0.5rem;
}
.service .serviceBox2{
  background: #f7f8fa;
  overflow: hidden;
  padding-bottom:0.2rem;
  padding-top:0.5rem;
}
.serviceBox2 ul{
  margin:0 0.3rem;
}
.serviceBox2 ul li{
  background:#fff;
  border:0.01rem solid #ccc;
  margin-bottom:0.3rem;
  padding:0.4rem 0 0.45rem 0.25rem;
}
.serviceBox2 ul li i{
  float:left;
  width:0.9rem;
  height:1.2rem;
}
.serviceBox2 ul li i img{
  display:block;
  width:0.9rem;
  height:1.2rem;
}
.serviceBox2 ul li h6{
  font:0.36rem 'MicrosoftYaHei';
  margin-left:1.2rem;
}
.serviceBox2 ul li .serviceTxt{
  margin-left:1.2rem;
}
.serviceBox2 ul li .serviceTxt p{
  float:left;
  border-right:0.01rem solid #ccc; 
  padding:0 0.2rem;
  width:1.4rem;
  margin-top:0.35rem;
}
.serviceBox2 ul li .serviceTxt p img{
   display:inline-block;
   width:0.3rem;
   height:0.4rem;
   margin-right:0.1rem;
}
.serviceBox2 ul li .serviceTxt p span{
  display:inline-block;
  text-align:center;
  width:1rem;
  font:0.24rem 'MicrosoftYaHei';
  color:#666;
}
.serviceBox2 ul li .serviceTxt p.te{
   padding-left:0rem;
}
.serviceBox2 ul li .serviceTxt p.Noline{
  border:none;
}

.service .serviceBox3{
  background:#f7f8fa;
}
.logosBox{
  width:5.39rem;
  margin:0 auto;
  padding-bottom:0.5rem;
  margin-top:0.5rem;
}
.logosBox img{
  display:block;
  width:100%;
}


.service .serviceBox4{
  background:#fff;
  padding-top: 0.5rem;
}
.service .serviceBox4 h4{
  font: 0.4rem 'MicrosoftYaHei';
  width: 100%;
  text-align: center;
  color: #333;
}
.service .serviceBox4 ul{
  
}
.service .serviceBox4 ul li{
  margin-top:0.5rem;
}
.service .serviceBox4 ul .logo{
  width:3.4rem;
  margin:0 auto 0.55rem;
}
.service .serviceBox4 ul .logo img{
  width:100%;
  display:block;
}
.service .serviceBox4 ul .tit{
  width:100%;
  text-align:center;
  line-height:0.6rem;
  color:#333;
  font-size:0.3rem;
  margin-bottom:0.3rem;
}
.service .serviceBox4 ul li:last-child .tit{
  font-size:0.26rem;
}
.service .serviceBox4 ul .txt{
  width:6.6rem;
  margin:0 auto;
  line-height:0.48rem;
  color:#999;
  font-size:0.24rem;
  text-indent:2em;
}


</style>



// WEBPACK FOOTER //
// src/components/service.vue